import { newsDigest } from '@/mocks/homeData';
import SectionHeading from './SectionHeading';

const notices = [
  { icon: 'ri-shield-check-line', text: '浏览前建议先阅读使用规范与安全提示。' },
  { icon: 'ri-error-warning-line', text: '外链内容请自行判断，注意个人信息安全。' },
  { icon: 'ri-refresh-line', text: '帮助说明随使用反馈持续更新，欢迎回来复查。' },
];

export default function NewsDigest() {
  return (
    <section className="w-full px-4 md:px-8 py-14 md:py-20 bg-background-100">
      <div className="w-full max-w-6xl mx-auto">
        <SectionHeading
          eyebrow="更新短讯"
          title="最近有这些说明与调整"
          desc="帮助中心与使用教程的更新都会在这里同步，短句为主，一眼看完。"
        />

        <div className="mt-10 grid grid-cols-1 lg:grid-cols-3 gap-6">
          <div className="lg:col-span-2 bg-background-50 border border-background-200 rounded-lg divide-y divide-background-200">
            {newsDigest.map((item) => (
              <div
                key={`${item.date}-${item.tag}`}
                className="flex items-start gap-4 px-4 md:px-5 py-4 hover:bg-primary-100/40 transition-colors"
              >
                <span className="shrink-0 w-14 text-center font-heading text-lg text-primary-600">{item.date}</span>
                <span className="shrink-0 mt-0.5 px-2 py-0.5 rounded-md bg-secondary-100 text-secondary-900 text-xs whitespace-nowrap">
                  {item.tag}
                </span>
                <p className="text-sm text-foreground-700 leading-relaxed">{item.text}</p>
              </div>
            ))}
          </div>

          <aside className="flex flex-col gap-4">
            <div className="bg-foreground-950 rounded-lg p-5 text-background-100">
              <div className="flex items-center gap-2 text-primary-300">
                <i className="ri-megaphone-line text-lg"></i>
                <span className="font-heading text-lg tracking-wide">使用提醒</span>
              </div>
              <ul className="mt-4 space-y-3">
                {notices.map((n) => (
                  <li key={n.text} className="flex items-start gap-2.5 text-sm leading-relaxed">
                    <i className={`${n.icon} text-primary-400 mt-0.5`}></i>
                    <span className="text-background-200">{n.text}</span>
                  </li>
                ))}
              </ul>
            </div>

            <div className="bg-accent-100 border border-accent-200 rounded-lg p-5">
              <div className="flex items-center gap-2 text-accent-700">
                <i className="ri-customer-service-2-line text-lg"></i>
                <span className="font-heading text-lg tracking-wide">需要帮助？</span>
              </div>
              <p className="mt-3 text-sm text-foreground-700 leading-relaxed">
                遇到问题可先看常见问题，仍无法解决就提交反馈，写清操作步骤会处理得更快。
              </p>
              <a
                href="#feedback"
                className="mt-4 inline-flex items-center gap-1.5 px-4 py-2 rounded-md bg-accent-500 text-background-50 text-sm hover:bg-accent-600 transition-colors cursor-pointer whitespace-nowrap"
              >
                <i className="ri-send-plane-line"></i>
                前往反馈
              </a>
            </div>
          </aside>
        </div>
      </div>
    </section>
  );
}